import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";

// Lazy-load non-homepage routes to reduce initial bundle size
const ServicesPage = lazy(() => import("./pages/ServicesPage"));
const ServiceDetailPage = lazy(() => import("./pages/ServiceDetailPage"));
const TwilightPhotographyPage = lazy(() => import("./pages/TwilightPhotographyPage"));
const VirtualStagingPage = lazy(() => import("./pages/VirtualStagingPage"));
const AgentOnCameraPage = lazy(() => import("./pages/AgentOnCameraPage"));
const ListingWebsitePage = lazy(() => import("./pages/ListingWebsitePage"));
const LocationsPage = lazy(() => import("./pages/LocationsPage"));
const ArkansasPage = lazy(() => import("./pages/ArkansasPage"));
const WashingtonPage = lazy(() => import("./pages/WashingtonPage"));
const StateSlugResolver = lazy(() => import("./pages/StateSlugResolver"));
const PricingPage = lazy(() => import("./pages/PricingPage"));
const PortfolioPage = lazy(() => import("./pages/PortfolioPage"));
const AboutPage = lazy(() => import("./pages/AboutPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const BookPage = lazy(() => import("./pages/BookPage"));
const AdminPortfolioPage = lazy(() => import("./pages/AdminPortfolioPage"));
const TestimonialsPage = lazy(() => import("./pages/TestimonialsPage"));
const PrivacyPage = lazy(() => import("./pages/PrivacyPage"));
const TermsPage = lazy(() => import("./pages/TermsPage"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/twilight-photography" element={<TwilightPhotographyPage />} />
            <Route path="/services/virtual-staging" element={<VirtualStagingPage />} />
            <Route path="/services/agent-on-camera" element={<AgentOnCameraPage />} />
            <Route path="/services/listing-website" element={<ListingWebsitePage />} />
            <Route path="/services/:serviceSlug" element={<ServiceDetailPage />} />
            <Route path="/locations" element={<LocationsPage />} />
            <Route path="/washington" element={<WashingtonPage />} />
            <Route path="/arkansas" element={<ArkansasPage />} />
            <Route path="/:stateSlug/:slug" element={<StateSlugResolver />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/book" element={<BookPage />} />
            <Route path="/admin/portfolio" element={<AdminPortfolioPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
